export enum VactionCalculateSystem {
  Allotment,
  Accrual,
}

export const VactionCalculateSystemOptions = [
  { id: VactionCalculateSystem.Allotment, name: 'Allotment' },
  { id: VactionCalculateSystem.Accrual, name: 'Accrual' },
];
